export default "__VITE_ASSET__BGvO4Oou__"